export const categories = [
  { slug: 'yulequan', name: '娱乐圈', icon: 'ri-movie-line', description: '明星八卦、影视动态、独家爆料' },
  { slug: 'wanghongquan', name: '网红圈', icon: 'ri-live-line', description: '网红动态、直播趣事、粉丝互动' },
  { slug: 'tiyuquan', name: '体育圈', icon: 'ri-basketball-line', description: '赛事热点、运动员动态、转会消息' },
  { slug: 'kejiquan', name: '科技圈', icon: 'ri-smartphone-line', description: '科技大佬、产品发布、行业动态' },
  { slug: 'shehuiredian', name: '社会热点', icon: 'ri-fire-line', description: '民生话题、热点事件、深度追踪' },
  { slug: 'guojishiye', name: '国际视野', icon: 'ri-global-line', description: '海外资讯、国际热点、全球视角' },
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);